import { DateTime } from "luxon";
import { GateSystemRef } from "../../shared/refs";
import { GateComponent } from "./gateComponent";
import { isNotNullOrUndefined } from "../../../shared/utils/utils";

export class PredictiveService {
  // Predictive Service is just a Gate Component with data structured differently
  id?: string | undefined;
  gateSystemLabel?: string;
  gateComponentLabel?: string;
  uptimeMaintenance?: number | null;
  maxOperatingTime?: number | null;
  currentInspectionLoadChanges?: number | null;
  maintenanceDuringLoadChanges?: number | null;
  currentReplacementLoadChanges?: number | null;
  maxLoadChanges?: number | null;
  daysToNextInspection?: number;
  daysToNextReplacement?: number;
  gateSystem?: GateSystemRef;
  currentGateSystemLoadChanges?: number;
  startDate?: number;
  dateOfInspection?: number;

  constructor(gateComponent: GateComponent) {
    this.gateSystem = gateComponent.gateSystem;

    if (gateComponent.uptimeMaintenance) {
      this.daysToNextInspection = this.getDaysToNextInspection(
        gateComponent.startDate!,
        gateComponent.uptimeMaintenance!,
        gateComponent.dateOfInspection
      );
    }

    if (gateComponent.maxOperatingTime) {
      this.daysToNextReplacement = this.getDaysToNextReplacement(
        gateComponent.startDate!,
        gateComponent.maxOperatingTime!,
        gateComponent.dateOfReplacement
      );
    }

    this.id = gateComponent.id?.toString();
    this.gateSystemLabel = gateComponent.gateSystem?.label ? gateComponent.gateSystem?.label : "";
    this.gateComponentLabel = gateComponent.label;
    this.uptimeMaintenance = gateComponent.uptimeMaintenance ? gateComponent.uptimeMaintenance : null;
    this.maxOperatingTime = gateComponent.maxOperatingTime ? gateComponent.maxOperatingTime : null;
    this.currentInspectionLoadChanges = gateComponent.currentInspectionLoadChanges
      ? gateComponent.currentInspectionLoadChanges
      : null;
    this.currentInspectionLoadChanges =
      gateComponent.maintenanceDuringLoadChanges !== null && gateComponent.maintenanceDuringLoadChanges !== 0
        ? gateComponent.currentInspectionLoadChanges
        : null;
    this.maintenanceDuringLoadChanges = gateComponent.maintenanceDuringLoadChanges
      ? gateComponent.maintenanceDuringLoadChanges
      : null;
    this.currentReplacementLoadChanges =
      gateComponent.maxLoadChanges !== null && gateComponent.maxLoadChanges !== 0
        ? gateComponent.currentReplacementLoadChanges
        : null;
    this.maxLoadChanges = gateComponent.maxLoadChanges ? gateComponent.maxLoadChanges : null;
    this.startDate = gateComponent.startDate;
    if (isNotNullOrUndefined(gateComponent.dateOfInspection)) {
      this.dateOfInspection = gateComponent.dateOfInspection;
    }
  }

  /**
   * Sets the current load changes of the gate system and updates the predictive maintenance days.
   * @param realtimeLoadChanges the new load changes of the gate system
   */
  public setRealtimeLoadChanges(realtimeLoadChanges: number) {
    if (this.currentGateSystemLoadChanges === undefined) {
      this.currentGateSystemLoadChanges = realtimeLoadChanges;
    } else {
      const diff = realtimeLoadChanges - this.currentGateSystemLoadChanges;
      if (isNotNullOrUndefined(this.currentInspectionLoadChanges)) {
        this.currentInspectionLoadChanges += diff;
      }
      if (isNotNullOrUndefined(this.currentReplacementLoadChanges)) {
        this.currentReplacementLoadChanges += diff;
      }
      this.currentGateSystemLoadChanges = realtimeLoadChanges;
    }
  }

  getDaysToNextInspection(startDate: number, uptimeMaintenance: number, dateOfInspection?: number | null) {
    const now = DateTime.now().toMillis();
    let startingPoint = startDate;
    if (dateOfInspection !== undefined && dateOfInspection !== null) {
      startingPoint = dateOfInspection;
    }
    const inspection = startingPoint + uptimeMaintenance * 24 * 60 * 60 * 1000;
    const daysToNextInspection = Math.round((inspection - now) / (24 * 60 * 60 * 1000));
    return daysToNextInspection;
  }
  getDaysToNextReplacement(startDate: number, maxOperatingTime: number, dateOfReplacement?: number | null) {
    const now = DateTime.now().toMillis();
    const startingPoint = dateOfReplacement || startDate;
    const replacement = startingPoint + maxOperatingTime * 24 * 60 * 60 * 1000;
    const daysToNextReplacement = Math.round((replacement - now) / (24 * 60 * 60 * 1000));
    return daysToNextReplacement;
  }
}
